import { render, staticRenderFns } from "./CustomGroupSelect.vue?vue&type=template&id=0b9ce783&scoped=true"
import script from "./CustomGroupSelect.vue?vue&type=script&lang=js"
export * from "./CustomGroupSelect.vue?vue&type=script&lang=js"
import style0 from "./CustomGroupSelect.vue?vue&type=style&index=0&id=0b9ce783&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9ce783",
  null
  
)

export default component.exports